import React from "react";
import { Icon } from "../bigpicture/components";
import "../styles/bp-leaderboard.css";

const MEDALS = { 1: ["#FFD54A", "#F5A700"], 2: ["#E3E8EF", "#9AA5B4"], 3: ["#F2B48A", "#C9733A"] };

function Rank({ rank }) {
  const medal = MEDALS[rank];
  if (!medal) return <span className="lb-rank-num">{rank}</span>;
  return (
    <span className="lb-medal" style={{ "--m1": medal[0], "--m2": medal[1] }}>
      {rank}
    </span>
  );
}

/** Top 5 (plus the player's own row below them when they are not in it). */
export default function Leaderboard({ leaderboard, rows, user }) {
  return (
    <section className="bp-lb">
      <div className="lb-hero">
        <div className="lb-ribbon">LEADERBOARD</div>
      </div>

      <div className="lb-head">
        <span className="c-rank">
          Rank
        </span>
        <span className="c-name">Name</span>
        <span className="c-points">
          <Icon name="star" /> Points
        </span>
        <span className="c-time">
          <Icon name="clock" /> Time
        </span>
      </div>

      {!leaderboard ? (
        <div className="lb-empty">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="lb-empty">No entries yet.</div>
      ) : (
        rows.map((r) => {
          const mine = String(r.userId) === String(user.userId);
          const detached = leaderboard.me && r === leaderboard.me;
          return (
            <div
              key={r.rank}
              className={`lb-row rank-${r.rank <= 3 ? r.rank : "n"}${mine ? " me" : ""}${detached ? " detached" : ""}`}
            >
              <span className="c-rank">
                <Rank rank={r.rank} />
              </span>
              <span className="c-name">
                <span className="lb-name">{r.name}</span>
              </span>
              <span className="c-points">
                <Icon name="star" /> {r.points}
              </span>
              <span className="c-time">
                <Icon name="clock" /> {r.time}
              </span>
            </div>
          );
        })
      )}
    </section>
  );
}
